import type { TargetLanguage } from "./languages";
import { UI_COPY } from "./uiCopy";

export function applyDocumentMetadata(language: TargetLanguage): () => void {
  const previousLanguage = document.documentElement.lang;
  const previousTitle = document.title;
  let descriptionMeta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
  const createdDescriptionMeta = !descriptionMeta;

  if (!descriptionMeta) {
    descriptionMeta = document.createElement("meta");
    descriptionMeta.name = "description";
    document.head.append(descriptionMeta);
  }

  const previousDescription = descriptionMeta.content;
  const copy = UI_COPY[language];
  document.documentElement.lang = language === "zh" ? "zh-CN" : language;
  document.title = copy.appName;
  descriptionMeta.content = copy.metaDescription;

  return () => {
    document.documentElement.lang = previousLanguage;
    document.title = previousTitle;
    if (createdDescriptionMeta) {
      descriptionMeta.remove();
    } else {
      descriptionMeta.content = previousDescription;
    }
  };
}
